import {PlayClass} from "../../models/class-structure/generic/PlayClass";
import {ClassStep} from "../../models/class-structure/generic/ClassStep";
import {EndStepAction, PreviousStepAction} from "../../models/types/ClassTypes";

import {analyticsController} from "../../../user/analytics/AnalyticsController";
import {songService} from "../../../playable/SongService";
import {userService} from "../../../user/UserService";

export abstract class AbstractPlayClassController {
  /* Class Content */
  public readonly playClass: PlayClass;
  public abstract readonly orderedClassControllers: AbstractPlayClassController[];
  public get orderedClasses(): PlayClass[] {
    return this.orderedClassControllers.map((classController) => classController.playClass)
  };

  /* Class Status */
  public isFinished: boolean = false;

  /* Demo Status */
  readonly hasDemo: boolean;
  public isDemoCompleted: boolean;
  public get shouldDisplayDemo(): boolean {
    return this.hasDemo && !this.isDemoCompleted;
  }

  protected constructor(playClass: PlayClass, hasDemo: boolean = false) {
    this.playClass = playClass;
    this.hasDemo = hasDemo;

    this.isDemoCompleted = playClass.progress.total > 0 && playClass.progress.total < 1 && playClass.playableContent.playableType === 'section'

    // this.isDemoCompleted = false; // TODO: Should we add a skip demo parameter
  }

  /* Class Accessor */
  abstract get activeClass(): PlayClass
  abstract get activeStep(): ClassStep
  abstract get previousStep(): ClassStep | null

  /* Class Manipulation */
  abstract loadNextStep(): EndStepAction;
  abstract loadPreviousStep(): PreviousStepAction;
  abstract setClassAndStep(classId: number, stepId: number|'demo'): void;

  /* Class Utils */
  protected isClassStarted(): boolean {
    return this.orderedClasses.some((playClas: PlayClass) => playClas.progress.maxStepId >= 0);
  }

  get activeClassIndex(): number {
    return this.orderedClasses.indexOf(this.activeClass);
  }
}

export function logSendInBlueClassEvent(eventName: string) {
  analyticsController.logSendInBlueEvent({
    event_name: eventName,
    event_data: {
      id: `${userService.user.id}:${songService.state.currentVersion.id}`,
      data: songService.state.currentVersion.getAnalyticsData(),
    }
  });
}

